export type CarouselSlide = {
  src: string
  label: string
  alt: string
}

export const carouselSlides: CarouselSlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/saETyq1jzgBLkAGCAGPDCQ/Captura_de_pantalla_2026-10-11_015912.png',
    label: 'Visual Technique Breakdown',
    alt: 'Coaching page: Escaping mount starts with elbow position — mount survival checklist with annotated photo',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/iywhaUwC77rsaBQ6EAsM6b/Captura_de_pantalla_2026-10-11_015836.png',
    label: 'Step-by-Step Skill Progression',
    alt: 'Coaching page: Closed guard — control before attack, with the 6-point structure of a functional closed guard',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ioj2CGBZ4kjKMJQNQQr194/Captura_de_pantalla_2026-10-11_015726.png',
    label: 'Coach Decision Map',
    alt: 'Coaching page: Read the guard before you pass — guard-type to pass-type decision map',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cnamiGZUdFwU7Qss9a74Z9/Captura_de_pantalla_2026-10-11_015626.png',
    label: 'Guard Retention Framework',
    alt: 'Coaching page: Don’t let them pass your knees — guard retention response map',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cvbrLigNuYGPaDzHE2qGMa/Captura_de_pantalla_2026-10-11_015602.png',
    label: 'Ready-to-Use Class Structure',
    alt: 'Coaching page: The 8 pillars of BJJ development — movement, guard, escapes, passing, top control, back control, submissions, transitions',
  },
]
